import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
} from "@material-ui/core"

const DialogConfiguracoes = ({
    todasMesas,
    classes,
    mesa,
    openConfiguracoes,
    handleCloseConfiguracoes,
    numeroMesa,
    handleChangeNumeroMesa,
    mudarMesa,
}) => {
    return (
        <Dialog open={openConfiguracoes} onClose={handleCloseConfiguracoes} fullWidth>
            <DialogTitle>Configurações</DialogTitle>
            <DialogContent>
                <Grid container xs={12} sm={6} md={6}>
                    <FormControl fullWidth>
                        <InputLabel variant="outlined">Mesa</InputLabel>
                        <Select
                            variant="outlined"
                            value={numeroMesa}
                            label="Mesa"
                            onChange={handleChangeNumeroMesa}
                        >
                            {todasMesas.map((_, index) =>
                                index === 0 ? null : (
                                    <MenuItem key={index} value={index}>
                                        {index}
                                    </MenuItem>
                                )
                            )}
                        </Select>
                    </FormControl>
                </Grid>
            </DialogContent>
            <DialogActions className={classes.actionsConfiguracoes}>
                <Button onClick={handleCloseConfiguracoes}>Fechar</Button>
                <Button
                    onClick={() => {
                        if (mesa.numeroMesa !== numeroMesa) {
                            mudarMesa(numeroMesa)
                        }
                        handleCloseConfiguracoes()
                    }}
                >
                    Salvar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default DialogConfiguracoes
